import PosterImageToCanvas from "./PosterImageToCanvas";
import FrameImagePreloader from "./FrameImagePreloader";
import None from "./Frames/None.js";
import BlackList from "./Frames/BlackList";
import LightOakList from "./Frames/LightOakList";

export default class PosterFrameHandler
{
    /**
     * @param {object} options
     */
    constructor(options) {
        this.preloadedFrames = FrameImagePreloader.getFrames();
        this.$originalImages = options.images;
        this.dataElement = this.$originalImages.parent().parent().parent().find('.custom-product-data');
        this.frameImagePreloader = options.frameImagePreloader;
        this.onClickSelectors = options.onclickSelectors;
        this.options = options;
    }

    /**
     * @returns void
     */
    addFrames(callback = () => {}) {

        // Uncomment this line (ONLY UNCOMMENT) in case we do not want to run JS to add frame during load
        // NOTICE!
        // 1) Uncomment can result in LCP issue rendering the detail image!!!
        // 2) The only option right now is to uncomment because otherwise the frame doesn't load during load on products with variants
        // consider only loading using JS on products with variants. at least as a temporary solution
        // this.replaceImagesWithCanvasElements();

        // Trigger only if events exist and when they are called
        if (this.onClickSelectors.length) {
            this.triggerOnEvents();
        }
        callback();
    }

    /**
     * @returns void
     */
    triggerOnEvents() {
        let self = this;
        for (let i = 0; this.onClickSelectors.length > 0; i++) {
            if (typeof this.onClickSelectors[i] === 'undefined') {
                break;
            }
            let action = 'click';
            if (this.onClickSelectors[i].is('select')) {
                action = 'change';
            }
            this.onClickSelectors[i].on(action, function () {
                setTimeout(() => {
                    self.applySelectedFrame(jQuery(this), action);
                }, 0)
            });
        }
    }

    /**
     * @param {jQuery} $clickedItem
     * @param {string} action
     */
    applySelectedFrame($clickedItem, action)
    {
        // Look for the image selectors (the frame images)
        let $checkedItemImageSelector = jQuery('body').find('.swoo-field:not(.swoo-hide)').find('.swoo-image-swatch.swoo-active');

        // If a text selector were clicked, and it's extra large
        let $checkedItemTextSelector = $clickedItem.parent().find('.swoo-text-swatch.swoo-active');
        if ($checkedItemTextSelector !== null && $checkedItemTextSelector.find('.swoo-title').text().trim() === 'Extra large') {
            // Then remove the frame since we do not sell frames with extra large posters
            return this.replaceImagesWithCanvasElements(new None());
        }

        let selectedFrame = null;
        let label = $checkedItemImageSelector.find('.swoo-option-label').text().trim() + this.getUniqueFrameNamePostfix();
        let frameType = $checkedItemImageSelector.closest('.wapf-field-container').find('.wapf-field-label label span').text();

        for (const preloadedFrame of this.preloadedFrames) {
            if (label === preloadedFrame.label) {
                selectedFrame = preloadedFrame;

                // Todo: Find a better solution than this temporary fix for changing poster lists
                if (frameType === 'Plakatliste') {
                    // If black frame
                    if (preloadedFrame.number === 1) {
                        selectedFrame = new BlackList();
                        // If light oak frame
                    } else if (preloadedFrame.number === 2) {
                        selectedFrame = new LightOakList()
                    }
                }
                break;
            }
        }

        // Use the current frame setting if the action is the builtin WordPress variation selector (a "change" event)
        if (action === 'change') {
            selectedFrame = this.previousFrame;
        }

        this.replaceImagesWithCanvasElements(selectedFrame);
        this.previousFrame = selectedFrame;
    }

    /**
     * @param {Frame} selectedFrame
     */
    replaceImagesWithCanvasElements(selectedFrame = null) {
        let self = this;
        let $orgPosterImages = this.$originalImages;
        $orgPosterImages.each(function() {
            self.options.selectedFrame = selectedFrame;
            self.options.$orgPosterImage = jQuery(this);

            // We do this to show the hidden element when the canvas is loaded to avoid showing the original image during load
            self.waitForElementHiddenBeforeShowing(jQuery(this), jQuery(this).closest(self.options.hiddenSelectorToShowAfterLoad));

            self.options.frameImagePreloader = self.frameImagePreloader;
            let posterImageToCanvas = new PosterImageToCanvas(self.options);
            posterImageToCanvas.replaceImage();
        });
    }
    /**
     * @returns void
     */
    bringBackOriginalImageWithoutFrame() {
        let $oldCanvas = this.$originalImages.parent().find('canvas');
        $oldCanvas.hide();
        let $productImage = this.$originalImages;
        $productImage.show();
    }

    /**
     * @returns {string}
     */
    getUniqueFrameNamePostfix() {
        let frameCount = parseInt(this.dataElement.data('frame-count'));
        if (frameCount > 1) {
            return ' (' + frameCount + ' rammer)';
        }
        return '';
    }

    /**
     * @returns this
     */
    waitForElementHiddenBeforeShowing(waitForElement, toShowElement) {
        let interval = setInterval(() => {
            // When the poster image is hidden
            if (waitForElement.is(":hidden")) {
                // Then show all the images
                toShowElement.css("visibility", "visible");
                toShowElement.parent().find('.spinner').hide();
                clearInterval(interval);
            }
        }, 250);
        return this;
    }
}
